import { h$1 as u, Y as D, h as g, me as B, m as T, o as w } from "../chunks/register-Ba9sFUKZ.js";
import * as F from "react";
import { O as S, v as A } from "../chunks/hintable-Dyo_YHGL.js";
import { D as I } from "../chunks/errorable-C1SCG9qs.js";
import { v as $ } from "../chunks/mixin-CP6jLr_x.js";
import { x as f } from "../chunks/lifecycle-decorators-C04d1yHY.js";
import { u as k } from "../chunks/showIfUsed-5lEKgJ0L.js";
const p = {
  beaconTagName: "beacon-control-group"
}, q = u`[beacon-tag-name=beacon-control-group] [slot=label]:not(label){font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control] label{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has(input)[toggle-switch] label{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has(input[aria-disabled=true],:disabled) label{color:var(--beacon-system-color-text-inactive)}[beacon-tag-name=beacon-control-group] [beacon-tag-name=beacon-control]:has([type=radio],[type=checkbox]){padding-block:var(--beacon-reference-space-3);padding-inline-end:var(--beacon-reference-space-3)}`, C = u`fieldset{border:0;margin:0;padding:0}legend{margin-block-end:var(--beacon-reference-space-3);padding:0}.error:not(.visible){display:none}.hint{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.hint,.error{margin-block-start:var(--beacon-reference-space-3)}`;
var y = (n) => {
  throw TypeError(n);
}, E = (n, e, t) => e.has(n) || y("Cannot " + t), m = (n, e, t) => (E(n, e, "read from private field"), t ? t.call(n) : e.get(n)), v = (n, e, t) => e.has(n) ? y("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(n) : e.set(n, t), l = (n, e, t, a) => (E(n, e, "write to private field"), e.set(n, t), t), N = Object.defineProperty, M = Object.getOwnPropertyDescriptor, d = (n, e, t, a) => {
  for (var r = M(e, t), c = n.length - 1, h; c >= 0; c--)
    (h = n[c]) && (r = h(e, t, r) || r);
  return r && N(e, t, r), r;
}, i, s;
const b = class extends $(B).with(
  S,
  I,
  A
) {
  constructor() {
    super(...arguments), v(this, i), v(this, s), this.beaconTagName = p.beaconTagName, this.resetSpacing = !0, this.focusOverride = !0, l(this, i, !1), l(this, s, "false");
  }
  static get styles() {
    return [super.styles, C];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, q];
  }
  get required() {
    return m(this, i);
  }
  set required(e) {
    l(this, i, e), this.controls.length > 0 && this.controls.forEach((t) => this.setRequiredToField(t));
  }
  _postSetDisabled() {
    this.controls.length > 0 && this.controls.forEach((e) => this.setDisabledToField(e));
  }
  get isAriaDisabled() {
    return m(this, s);
  }
  set isAriaDisabled(e) {
    l(this, s, e), this.controls.length > 0 && this.controls.forEach((t) => this.setDisabledToField(t, "aria"));
  }
  _postSetInvalid() {
    this.controls.length > 0 && this.controls.forEach((e) => this.setInvalidToField(e));
  }
  get controls() {
    return Array.from(
      this.querySelectorAll('[beacon-tag-name="beacon-control"]')
    );
  }
  getAriaDescribedByIds() {
    var e, t;
    const a = [(e = this.hintElement) == null ? void 0 : e.id];
    return this.invalid && a.push((t = this.errorElement) == null ? void 0 : t.id), a;
  }
  handleSlottedControlFieldSet(e) {
    const { target: t } = e;
    t && (this.disabled && this.setDisabledToField(t), this.isAriaDisabled && this.setDisabledToField(t, "aria"), this.invalid && this.setInvalidToField(t), this.required && this.setRequiredToField(t), this.setHintDataId(t), t.setFieldAriaDescribedBy(
      this.getAriaDescribedByIds()
    ));
  }
  setRequiredToField(e) {
    e.fieldElement && (e.fieldElement.required = this.required);
  }
  setDisabledToField(e, t = "boolean") {
    e.fieldElement && (t === "boolean" && (e.fieldElement.disabled = this.disabled), t === "aria" && e.fieldElement.setAttribute(
      "aria-disabled",
      String(this.isAriaDisabled)
    ));
  }
  setInvalidToField(e) {
    var t;
    e.fieldElement && (e.dataset.errorId = (t = this.errorElement) == null ? void 0 : t.id, e.fieldElement.setAttribute("aria-invalid", String(this.invalid)));
  }
  setHintDataId(e) {
    var t, a;
    e.fieldElement && (t = this.hintElement) != null && t.id && (e.dataset.hintId = (a = this.hintElement) == null ? void 0 : a.id);
  }
  render() {
    return D`
      <fieldset>
        <legend>
          <slot name="label" ${k({ useParent: !0 })}></slot>
        </legend>
        <div class="controls">
          <slot
            @beacon-event-control-set=${this.handleSlottedControlFieldSet}></slot>
        </div>
        ${this.renderHintTemplate()} ${this.renderErrorTemplate()}
      </fieldset>
    `;
  }
};
i = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), b.tagName = p.beaconTagName, b.nestedComponents = ["beacon-error"];
let o = b;
d([
  g({ type: Boolean, reflect: !0 })
], o.prototype, "required");
d([
  f("disabled")
], o.prototype, "_postSetDisabled");
d([
  g({ attribute: "aria-disabled" })
], o.prototype, "isAriaDisabled");
d([
  f("invalid")
], o.prototype, "_postSetInvalid");
const W = (n) => (T(n, o), w({
  tagName: n ? n + "-" + o.tagName : o.tagName,
  elementClass: o,
  react: F,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  W as default,
  W as reactBeaconControlGroup
};
